export const TransparentDropdownStyles = {
  control: (base) => ({
    ...base,
    '&:hover': { borderColor: 'transparent' },
    border: 'transparent',
    boxShadow: 'none',
    background: 'transparent',
    width: 130,
    fontFamily: 'Roboto',
  }),
  input: (base) => ({
    ...base,
    color: '#444444',
    fontSize: '14px',
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: 12,
    color: '#444444',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    marginTop: 9,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 28,
  }),
  option: (base) => ({
    ...base,
    fontSize: 12,
    borderBottom: '1px solid #EEEEEE',
    cursor: 'pointer',
    '&:last-child': { borderBottom: 0 },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: 0,
  }),
  menu: (base) => ({
    ...base,
    boxShadow: '0px 2px 4px rgba(147, 157, 177, 0.25)',
  }),
};

export const JobsDropdownStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: '0px 1px 2px 0px rgba(14, 24, 41, 0.05)',
    background: 'transparent',
    width: 130,
    fontFamily: 'Roboto',
    borderRadius: '6px',
    minHeight: 28,
    '&:hover': { borderColor: '#0FBC71', cursor: 'pointer' },
    borderColor: state.isFocused || state.isSelected ? '#0FBC71' : '#EAECF0',
  }),
  input: (base) => ({
    ...base,
    color: '#444444',
    fontSize: '14px',
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: 12,
    fontWeight: 600,
  }),
  option: (base, state) => ({
    ...base,
    fontSize: 12,
    cursor: 'pointer',
    fontWeight: 500,
    width: 208,
    '&:hover': !state.isSelected && { backgroundColor: '#D0FADF;', color: 'black' },
    backgroundColor: state.isSelected ? '#00bf69' : 'white',
  }),
  valueContainer: (base) => ({
    ...base,
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: 12,
    fontWeight: 600,
    color: '#1A293A',
  }),
  menu: (base) => ({
    ...base,
    boxShadow: '0px 2px 4px rgba(147, 157, 177, 0.25)',
    zIndex: 999,
    right: 0,
    width: 208,
  }),
};
